export const FirebaseConfig = {
	"projectId": "rylli-54657",
	"appId": "1:279758073559:web:ffd9e9dfeb9c02d77c4a92",
	"databaseURL": "https://rylli-54657-default-rtdb.firebaseio.com",
	"storageBucket": "rylli-54657.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyALYewjj4S1BCJJNxqi3lNusXAtEdDwOXQ",
	"authDomain": "rylli-54657.firebaseapp.com",
	"messagingSenderId": "279758073559",
	"measurementId": "G-VXZ2W32FJ7"
};